import { createSelector } from 'reselect';

// Config
import {
  getGetPayPalClientTokenCallActiveSelector,
  getGetPayPalClientTokenFailedSelector,
  getPayPalServiceUnavailableSelector,
  getPaymentNotSelectedErrorSelector,
  getSelectedPaymentTypeSelector,
  getShowPayPalServiceUnavailableErrorSelector,
} from '../../redux/reducers/payment/paymentSelector';

const payPalConnectMessageState = createSelector(
  [
    getSelectedPaymentTypeSelector,
    getShowPayPalServiceUnavailableErrorSelector,
    getPaymentNotSelectedErrorSelector,
    getGetPayPalClientTokenCallActiveSelector,
    getGetPayPalClientTokenFailedSelector,
    getPayPalServiceUnavailableSelector,
  ],
  (
    selectedPaymentType,
    showPayPalServiceUnavailableError,
    paymentNotSelectedError,
    getPayPalClientTokenCallActive,
    getPayPalClientTokenFailed,
    payPalServiceUnavailable,
  ) => ({
    showMessage:
      selectedPaymentType === undefined &&
      showPayPalServiceUnavailableError &&
      !paymentNotSelectedError &&
      !getPayPalClientTokenCallActive &&
      (getPayPalClientTokenFailed || payPalServiceUnavailable),
  }),
);

export default payPalConnectMessageState;
